import React from "react";
import "./SingleBannerStyle.scss";
import CustomButton from "components/Common_UI_Kit/CustomButton";

const SingleBannerSection = ({
  bannerTitleText,
  bannerParaText,
  btnText,
  bannerImageSrcContact,
  bannerImageSrc,
}) => {
  return (
    <section className="single-banner-section">
      <div className="single-banner-wrap">
        <div className="single-banner-box">
          <div className="text-box">
            {bannerTitleText && (
              <h1 className="title-text">{bannerTitleText}</h1>
            )}
            {bannerParaText && <p className="para-text">{bannerParaText}</p>}
            {btnText && (
              <div className="btn-box">
                <CustomButton buttonType="primary" label={btnText} />
              </div>
            )}
            {bannerImageSrcContact && (
              <a href="/contact-us" className="contact-img-box">
                <img src={bannerImageSrcContact} alt="Image" />
              </a>
            )}
          </div>

          {bannerImageSrc && (
            <div className="img-box">
              <img src={bannerImageSrc} alt="Image" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SingleBannerSection;
